import { render } from "./input.vue?vue&type=template&id=4b0889e6&ts=true"
import script from "./input.vue?vue&type=script&lang=ts"
export * from "./input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__